module.exports = __webpack_public_path__ + "static/media/PortEDI_BackImage.e27fdbd7.jpg";